import { Outlet } from "react-router-dom"

const Customerlayout = () => {
    return(
        <div>
            <Outlet />
        </div>
    );
}

export default Customerlayout;